import { StateSchema } from '@/hooks/form/models'
import {
  BonusType,
  ExpirationType,
  RolloverAmountCalculationEnum,
} from '@/enums'
import { DEFAULT_BONUS_PRIORITY } from '@/constants'

export const bonusPeriodSchema: StateSchema = {
  recurrence: {
    value: '',
    error: '',
  },
  startDate: {
    value: null,
    error: '',
  },
  startTime: {
    value: '00:00:00',
    error: '',
  },
  endDate: {
    value: null,
    error: '',
  },
  endTime: {
    value: '00:00:00',
    error: '',
  },
  recurrenceWeekday: {
    value: '',
    error: '',
  },
  day: {
    value: '',
    error: '',
  },
}

export const bonusDetailsSchema: StateSchema = {
  name: {
    value: '',
    error: '',
  },
  description: {
    value: '',
    error: '',
  },
  code: {
    value: '',
    error: '',
  },
  type: {
    // casino standard is the first option offered, so it starts out selected
    value: BonusType.CASINO_STANDARD,
    error: '',
  },
  priority: {
    value: DEFAULT_BONUS_PRIORITY,
    error: '',
  },
  ...bonusPeriodSchema,
}

export const triggerSchema = (currencies: string[]) => {
  let schema: StateSchema = {
    triggerBy: {
      value: '',
      error: '',
    },
    condition: {
      value: '',
      error: '',
    },
    depositCount: {
      value: '',
      error: '',
    },
    paymentMethods: {
      value: [],
      error: '',
    },
  }
  currencies.forEach((currency) => {
    schema = {
      ...schema,
      [`minimumDepositAmount_${currency}`]: {
        value: '',
        error: '',
      },
    }
  })
  return schema
}

export const bonusAmountSchema = (currencies: string[]) => {
  let schema: StateSchema = {
    amountType: {
      value: '',
      error: '',
    },
  }
  currencies.forEach((currency) => {
    schema = {
      ...schema,
      [`percentage_${currency}`]: {
        value: '',
        error: '',
      },
      [`cap_${currency}`]: {
        value: '',
        error: '',
      },
      [`fixed_${currency}`]: {
        value: '',
        error: '',
      },
    }
  })
  return schema
}

export const freeSpinsSchema: StateSchema = {
  freeSpinQuantity: {
    value: '',
    error: '',
  },
}

export const rolloverSettinsSchema = (currencies: string[]) => {
  let schema: StateSchema = {
    mode: {
      value: '',
      error: '',
    },
    rolloverCoefficcient: {
      value: '',
      error: '',
    },
    rollover: {
      value: '',
      error: '',
    },
    order: {
      value: '',
      error: '',
    },
  }
  currencies.forEach((currency) => {
    schema = {
      ...schema,
      [`rmMinAmount_${currency}`]: {
        value: '',
        error: '',
      },
    }
  })
  return schema
}

export const rolloverRestrictionsSchema = (currencies: string[]) => {
  let schema: StateSchema = {
    products: {
      value: [],
      error: '',
    },
    sports: {
      value: [],
      error: '',
    },
    wagerTypes: {
      value: [],
      error: '',
    },
    maxLine: {
      value: '',
      error: '',
    },
    minLine: {
      value: '',
      error: '',
    },
    rolloverAmountCalculationType: {
      value: RolloverAmountCalculationEnum.lowerAmount,
      error: '',
    },
  }
  currencies.forEach((currency) => {
    schema = {
      ...schema,
      [`minResetRealMoneyAmount_${currency}`]: {
        value: '',
        error: '',
      },
    }
  })
  return schema
}

export const restrictionsSchema = (currencies: string[]) => {
  let schema: StateSchema = {
    providerCategory: {
      value: '',
      error: '',
    },
    providers: {
      value: [],
      error: '',
    },
    products: {
      value: [],
      error: '',
    },
    sports: {
      value: [],
      error: '',
    },
    wagerTypes: {
      value: [],
      error: '',
    },
    maxLine: {
      value: '',
      error: '',
    },
    minLine: {
      value: '',
      error: '',
    },
    expirationType: {
      value: ExpirationType.TIME_UNIT,
      error: '',
    },
    expirationUnit: {
      value: '',
      error: '',
    },
    expirationDate: {
      value: new Date(new Date().setHours(0, 0, 0, 0)),
      error: '',
    },
    games: {
      value: [],
      error: '',
    },
    maxBonusesAllowed: {
      value: '',
      error: '',
    },
  }
  currencies.forEach((currency) => {
    schema = {
      ...schema,
      [`maxBet_${currency}`]: {
        value: '',
        error: '',
      },
      [`maxWin_${currency}`]: {
        value: '',
        error: '',
      },
    }
  })
  return schema
}

export const eligibilitySchema: StateSchema = {
  promotionalCodesAvailables: {
    value: [],
    error: '',
  },
  promotionalCodesUnavailables: {
    value: [],
    error: '',
  },
  creditCardTiersAvailables: {
    value: [],
    error: '',
  },
  creditCardTiersUnavailables: {
    value: [],
    error: '',
  },
  isEnable: {
    value: true,
    error: '',
  },
  agents: {
    value: [],
    error: '',
  },
  includeCountry: {
    value: true,
    error: '',
  },
  countries: {
    value: [],
    error: '',
  },
}

export const dependenciesSchema: StateSchema = {
  bonusBundle: {
    value: [],
    error: '',
  },
}

export const enableSchema: StateSchema = {
  isActive: {
    value: false,
    error: '',
  },
  // isMakeUpRule: {
  //   value: false,
  //   error: '',
  // },
}
